import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_28.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Head from "next/head";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter28.json";


export default function Chapter_28() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  return (
    <>
      <Head>
        <title>WOLFGANG PAULI’S THEORY | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXIX"
        ></meta>
        <meta
          property="og:title"
          content="WOLFGANG PAULI’S THEORY | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An abstract image blending quantum particles with spiritual symbols, representing Wolfgang Pauli's theory. The visual symbolizes the intersection of quantum physics and spirituality, illustrating the connection between the scientific exploration of reality and the divine consciousness."></meta>
        <meta
          property="og:description"
          content="Delve into Wolfgang Pauli’s Theory within the Central Doctrine of Divine Infinite Being. Uncover how Pauli’s insights into quantum physics intersect with spiritual principles, revealing the profound connection between science and the divine. Explore the bridge between consciousness and reality through Pauli’s revolutionary ideas."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=28"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An abstract image blending quantum particles with spiritual symbols, representing Wolfgang Pauli's theory. The visual symbolizes the intersection of quantum physics and spirituality, illustrating the connection between the scientific exploration of reality and the divine consciousness."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=28"></meta>
        <meta name="twitter:title" content="WOLFGANG PAULI’S THEORY | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Delve into Wolfgang Pauli’s Theory within the Central Doctrine of Divine Infinite Being. Uncover how Pauli’s insights into quantum physics intersect with spiritual principles, revealing the profound connection between science and the divine. Explore the bridge between consciousness and reality through Pauli’s revolutionary ideas."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=28" />
      </Head>


      <Common_html BlockData={BlockData} />
     
    </>
  );
}
